



























































import { Component, Provide, Vue } from 'vue-property-decorator'
import { PrintableDocument } from '@/api/model/printable-document'
import { PrintableDocumentAPI } from '@/api/backend-client'
import ListActions from '@/views/Company/Settings/EmmaDirectMail/PrintableDocuments/ListActions.vue'

@Component({
    components: { ListActions },
})
export default class CompanySettingsEmmaDirectMailPrintableDocumentsList extends Vue {
    loading: boolean = false
    printableDocuments: PrintableDocument[] = []

    async created(): Promise<void> {
        await this.reload()
    }

    @Provide()
    async reload(): Promise<void> {
        this.loading = true
        this.printableDocuments = await PrintableDocumentAPI.getAll({ company: this.$currentCompany.id })
        this.loading = false
    }

    async goToCreate(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_emma_direct_mail_printable_documents_create',
        })
    }

    getWebhookUrl(document: PrintableDocument) {
        return process.env.VUE_APP_KEYVUE_BACKEND_BASEURL +
            '/api/v1/service/active_campaign/send_document' +
            '?document=' + document.id
    }

    copyWebhookUrl(document: PrintableDocument) {
        this.copyToClipboard(this.getWebhookUrl(document))
        this.$notify({
            group: 'validation',
            text: this.$t('company_settings.emma_direct_mail.printable_documents.copied_webhook_url').toString(),
        })
    }

    // Source: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    copyToClipboard(str: string) {
        const el = document.createElement('textarea')
        el.value = str
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        if (selected) {
            document.getSelection().removeAllRanges()
            document.getSelection().addRange(selected)
        }
    }
}
